"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customPreload = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const customPreloadBase_1 = __importDefault(require("../../common/customPreloadBase"));
const sectionConfigs_1 = require("./sectionConfigs");
// TODO: Can we move this code to evolution-common or generate it with some function with the Generator?
// TODO: Do we really need to calculate _personsCount like this?
// TODO: It seems to be a workaround for the grouped objects not being able to have a count property.
// TODO: In other words, if we can improve the Group and Section navigation in Evolution, we can eliminate this file completely.
// Do some actions before the section is loaded
const customPreload = function (interview, { startUpdateInterview, startAddGroupedObjects, startRemoveGroupedObjects, callback }) {
    const responsesContent = (0, customPreloadBase_1.default)(interview, sectionConfigs_1.currentSectionName);
    // TODO: This code only depends on the grouped object path and group count path and section if count is invalid. Move to evolution, to make it generic.
    /** Start of group related code to move to evolution */
    const groupedObjects = (0, helpers_1.getResponse)(interview, 'household.persons');
    const groupedObjectIds = groupedObjects ? Object.keys(groupedObjects) : [];
    const householdSize = (0, helpers_1.getResponse)(interview, 'household.size', 0);
    const householdSizeIsValid = !isNaN(Number(householdSize)) && householdSize >= 1 && householdSize <= 18;
    const emptyGroupedObjects = groupedObjectIds.filter((groupedObjectId) => {
        const _a = groupedObjects[groupedObjectId], { _uuid, _sequence } = _a, restOfGroup = __rest(_a, ["_uuid", "_sequence"]);
        return (0, isEmpty_1.default)(restOfGroup);
    });
    if (householdSizeIsValid && householdSize) {
        responsesContent['response.household._personsCount'] = groupedObjectIds.length;
        if (groupedObjectIds.length < householdSize) {
            // auto create objects according to household size:
            startAddGroupedObjects(householdSize - groupedObjectIds.length, -1, 'household.persons', null, (_interview) => {
                responsesContent['response.household._personsCount'] = householdSize;
                startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
            });
        }
        else if (groupedObjectIds.length > householdSize) {
            const pathsToDelete = [];
            // auto remove empty objects according to household size:
            for (let i = 0; i < groupedObjectIds.length; i++) {
                if (emptyGroupedObjects[i]) {
                    pathsToDelete.push(`household.persons.${emptyGroupedObjects[i]}`);
                }
            }
            if (pathsToDelete.length > 0) {
                startRemoveGroupedObjects(pathsToDelete, (_interview) => {
                    responsesContent['response.household._personsCount'] =
                        groupedObjectIds.length - pathsToDelete.length;
                    startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
                });
            }
            else {
                responsesContent['response.household._personsCount'] = groupedObjectIds.length;
                startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
            }
        }
        else {
            responsesContent['response.household._personsCount'] = groupedObjectIds.length;
            startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
        }
    }
    else {
        responsesContent['response._activeSection'] = 'home';
        responsesContent['response.household._personsCount'] = undefined;
        startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
    }
    /** End of group related code to move to evolution */
    return null;
};
exports.customPreload = customPreload;
